import { Validator } from '@utils/validations/validation.type';

const TWENTY_FOUR_HOUR_TIME = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/;

export const isTime: Validator = ({ value, message }: { value: string; message: string }) => {
  if (!value) {
    return undefined;
  }
  const isValid = TWENTY_FOUR_HOUR_TIME.test(value);
  return isValid ? undefined : message;
};
